/**
 *「専門セミナー/特別企画受講申込」画面の初期化
 */
export function initVisitorSeminarApplicationIndex() {
    const article = document.getElementById("visitor-seminar-application-index");
    if (article === null)
        return;
    initCheckboxes();
}
/**
 * チェックボックスの初期化
 */
function initCheckboxes() {
    const elements = document.querySelectorAll('[id^="check-box-"]');
    // ページ読み込み時のcheckedの件数
    const defaultCheckCount = document.querySelectorAll('[id^="check-box-"]:checked').length;
    let enabled = false;
    if (defaultCheckCount > 0) {
        enabled = true;
        updateSubmitButton(enabled);
    }
    for (const element of elements) {
        const input = element;
        input.addEventListener("change", () => {
            const startAt = input.dataset.startAt;
            const endAt = input.dataset.endAt;
            for (const element of elements) {
                const target = element;
                if (input.id === target.id) {
                    continue;
                }
                const l = target.dataset.startAt;
                const r = target.dataset.endAt;
                if ((startAt <= r && endAt >= l)) {
                    target.checked = false;
                }
            }
            if (defaultCheckCount > 0) {
                // 開いた時点で1つ以上チェックが付いていた場合、チェックの有無にかかわらず押下可能
                enabled = true;
            }
            else {
                enabled = findCheckedElement(elements) !== null;
            }
            updateSubmitButton(enabled);
        });
    }
}
/**
 * 最初に見つかったチェック済みの要素を返す
 *
 * @param elements チェックボックスのノードリスト
 * @returns element | null
 */
function findCheckedElement(elements) {
    for (const element of elements) {
        const input = element;
        if (input.checked) {
            return element;
        }
    }
    return null;
}
/**
 * 送信ボタンを更新する
 *
 * @param enabled 使用可能かどうか
 */
function updateSubmitButton(enabled) {
    const button = document.getElementById("submit");
    if (button === null) {
        return;
    }
    button.disabled = !enabled;
}
